import { Dispatch } from 'react'
import type { WidgetState } from '../lib/types'

/** @internal */
export type ChatContextAction =
  | { msg: 'set_widget_state'; widget: WidgetState }
  | { msg: 'show_chat' }
  | { msg: 'hide_chat' }
  | { msg: 'toggle_chat' }
  | { msg: 'unread_msg'; count: number }
  | { msg: 'show_participants' }
  | { msg: 'hide_participants' }
  | { msg: 'toggle_participants' }
  | { msg: 'waiting_participants'; count: number }

/** @internal */
export type WidgetContextType = {
  dispatch?: Dispatch<ChatContextAction>
  state?: WidgetState
}

/** @internal */
export function chatReducer(state: WidgetState, action: ChatContextAction): WidgetState {
  let newState: WidgetState
  switch (action.msg) {
    case 'set_widget_state':
      return { ...action.widget }
    case 'show_chat':
      return { ...state, showChat: true, showParticipants: false, unreadMessages: 0 }
    case 'show_participants':
      return { ...state, showChat: false, showParticipants: true, waitingParticipants: 0 }
    case 'hide_chat':
      return { ...state, showChat: false }
    case 'hide_participants':
      return { ...state, showParticipants: false }
    case 'toggle_chat':
      newState = { ...state, showChat: !state.showChat }
      if (newState.showChat === true) {
        newState.showParticipants = false
        newState.unreadMessages = 0
      }
      return newState
    case 'toggle_participants':
      newState = { ...state, showParticipants: !state.showParticipants }
      if (newState.showParticipants === true) {
        newState.showChat = false
        newState.waitingParticipants = 0
      }
      return newState
    case 'unread_msg':
      return { ...state, unreadMessages: action.count }
    case 'waiting_participants':
      return { ...state, waitingParticipants: action.count }
    default:
      return { ...state }
  }
}
